import React, { useEffect } from 'react'

import {
  RESULTS_CONTAINER_ID, trackedIdentifier,
} from '../donate_v6/useEmployerMatching'

// Double the Donation's matching-gift plugin, required for partner certification.
// Bootstrap twin: donate_v6/EmployerMatchingResults.jsx.

const EmployerMatchingResults = ({ employerMatching, donation, shares, donationsPath }) => {
  const { enabled, failed, loaded } = employerMatching

  // The container only renders once loaded, so it's committed by now.
  useEffect(() => {
    if (!enabled || failed || !loaded) return

    const identifier = trackedIdentifier(donation, shares)
    employerMatching.loadResults(identifier,
      identifier && donation.token ? `${donationsPath}/${donation.token}` : null)
  }, [ loaded ])

  if (!enabled || failed || !loaded) return null

  return (
    // aria-live="off" so ThankYou's assertive region doesn't read the whole
    // plugin out. text-start undoes the panel's text-center.
    <div aria-live="off" className="employer-matching-results mt-6 text-start">
      <div id={RESULTS_CONTAINER_ID}></div>
    </div>
  )
}

export default EmployerMatchingResults
